
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { ChevronDown, Package, Truck, CheckCircle, XCircle } from "lucide-react";

interface BulkOrderActionsProps {
  selectedOrders: string[];
  onBulkAction: (action: string) => void;
  onClearSelection: () => void;
}

const BulkOrderActions = ({ 
  selectedOrders, 
  onBulkAction, 
  onClearSelection 
}: BulkOrderActionsProps) => {
  if (selectedOrders.length === 0) return null;

  const bulkActions = [
    { action: 'processing', label: 'Mark as Processing', icon: Package },
    { action: 'shipped', label: 'Mark as Shipped', icon: Truck },
    { action: 'delivered', label: 'Mark as Delivered', icon: CheckCircle },
    { action: 'cancelled', label: 'Cancel Orders', icon: XCircle },
  ];

  return (
    <div className="flex items-center gap-2 p-4 bg-blue-50 border border-blue-200 rounded-lg">
      <span className="text-sm font-medium text-blue-900">
        {selectedOrders.length} order{selectedOrders.length > 1 ? 's' : ''} selected
      </span>
      
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button size="sm" variant="outline">
            Bulk Actions
            <ChevronDown className="h-4 w-4 ml-2" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent>
          {bulkActions.map((action) => {
            const Icon = action.icon;
            return (
              <DropdownMenuItem
                key={action.action}
                onClick={() => onBulkAction(action.action)}
                className="flex items-center gap-2"
              >
                <Icon className="h-4 w-4" />
                {action.label}
              </DropdownMenuItem>
            );
          })}
        </DropdownMenuContent>
      </DropdownMenu>
      
      <Button size="sm" variant="ghost" onClick={onClearSelection}>
        Clear Selection
      </Button>
    </div>
  );
};

export default BulkOrderActions;
